import React from 'react';

import { cn } from './utils';


/** Panel / card surface — surface-1, hairline border, lg radius, soft shadow (DESIGN.md `panel`). */
const Card = React.forwardRef((props, ref) => {
  const { className, ...restProps } = props;
  return (
    <div
      ref={ref}
      className={cn(
        'rounded-lg border border-hairline bg-surface-1 shadow-card',
        className,
      )}
      {...restProps}
    />
  );
});
Card.displayName = 'Card';

const CardHeader = React.forwardRef((props, ref) => {
  const { className, ...restProps } = props;
  return <div ref={ref} className={cn('flex flex-col gap-1 p-4', className)} {...restProps} />;
});
CardHeader.displayName = 'CardHeader';

const CardTitle = React.forwardRef((props, ref) => {
  const { className, ...restProps } = props;
  return (
    <h3
      ref={ref}
      className={cn('text-[15px] font-semibold tracking-[-0.1px] text-ink', className)}
      {...restProps}
    />
  );
});
CardTitle.displayName = 'CardTitle';

const CardContent = React.forwardRef((props, ref) => {
  const { className, ...restProps } = props;
  return <div ref={ref} className={cn('p-4 pt-0', className)} {...restProps} />;
});
CardContent.displayName = 'CardContent';

export { Card, CardContent, CardHeader, CardTitle };
export default Card;
